<template>
  <div
    :class="[
      'v2-app-shell',
      {
        'v2-app-shell--drawer-open': drawerOpen,
      }
    ]"
  >
    <div
      v-if="drawerOpen"
      class="v2-app-shell__overlay"
      @click="closeDrawer"
      aria-hidden="true"
    />

    <div
      :class="[
        'v2-app-shell__sidebar',
        { 'is-open': drawerOpen }
      ]"
    >
      <AppSidebar
        :mobile-open="drawerOpen"
        :collapsed="false"
        @nav="closeDrawer"
      />
    </div>

    <div class="v2-app-shell__main">
      <AppTopbar
        :title="title"
        @toggle-sidebar="toggleDrawer"
      />
      <main class="v2-app-shell__content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppSidebar from "./AppSidebar.vue";
import AppTopbar from "./AppTopbar.vue";
import { resolvePageTitle } from "@/views/memberDashboardV2/shell/pageTitle";

export default {
  name: "AppShell",
  components: { AppSidebar, AppTopbar },
  data() {
    return {
      drawerOpen: false,
    };
  },
  computed: {
    title() {
      return resolvePageTitle(this.$route && this.$route.path, this.$route && this.$route.query);
    },
  },
  watch: {
    "$route.path"() {
      this.closeDrawer();
    },
  },
  methods: {
    toggleDrawer() {
      this.drawerOpen = !this.drawerOpen;
    },
    closeDrawer() {
      this.drawerOpen = false;
    },
  },
};
</script>

<style scoped>
.v2-app-shell {
  display: block;
  min-height: 100vh;
  background-color: var(--color-bg);
  color: var(--color-text);
}

.v2-app-shell__overlay {
  position: fixed;
  inset: 0;
  background-color: var(--overlay-sidebar-mobile);
  z-index: var(--z-modal);
  opacity: 0;
  pointer-events: none;
  transition: opacity var(--transition-base);
}

.v2-app-shell--drawer-open .v2-app-shell__overlay {
  opacity: 1;
  pointer-events: auto;
}

.v2-app-shell__sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: var(--layout-sidebar-expanded);
  max-width: 85vw;
  background: var(--gradient-chamber);
  z-index: var(--z-modal);
  transform: translateX(-100%);
  transition: transform var(--transition-base);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--color-navy-on);
}

.v2-app-shell__sidebar.is-open {
  transform: translateX(0);
}

.v2-app-shell__main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 0;
}

.v2-app-shell__content {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  padding-bottom: var(--layout-bottom-nav-home);
}

@media (min-width: 1024px) {
  .v2-app-shell {
    padding-left: var(--layout-sidebar-expanded);
  }

  .v2-app-shell__sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    transform: none;
    z-index: var(--z-sticky);
    box-shadow: var(--shadow-sidebar);
  }

  .v2-app-shell__main {
    padding-top: var(--layout-topbar-height);
  }

  .v2-app-shell__content {
    padding-bottom: 0;
  }

  .v2-app-shell__overlay {
    display: none;
  }
}
</style>